<template>
    <section class="about-hero">
        <div class="about-hero-text">
            <h1>About Us </h1>
            <p>Discover the story behind our passion for quality leather and timeless craftsmanship.</p>
        </div>

        <div class="about-hero-image">
            <img 
            :src="leatherCraft2"
            alt="Our Leather Collection">
        </div>
    </section>
</template>

<script>
import leatherCraft2 from '@/assets/leathercraft2.jpg'

export default {
  name: 'AboutPage',

  data() {
    return {
      leatherCraft2
    }
  }
}
</script>


<style scoped>
.about-hero {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 50px;
    padding: 70px 8%;
    background-color: #f5f0e8;
}

.about-hero-text{
    width: 45%;
}

.about-hero-text h1{
    font-size: 50px;
    color: #292929;
    margin-bottom: 20px;
}

.about-hero-text p{
    color: #4a4541;
    font-size: 18px;
    line-height: 1.7;
}

.about-hero-image{
    width: 45%;
}

.about-hero-image img{
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 8px;
}

/* ABOUT HERO RESPONSIVENESS */

@media (max-width: 768px) {

  .about-hero {
    flex-direction: column;
    text-align: center;
    padding: 50px 30px;
    gap: 30px;
  }

  .about-hero-text {
    width: 100%;
  }

  .about-hero-text h1 {
    font-size: 36px;
  }

  .about-hero-text p {
    font-size: 16px;
    line-height: 1.6;
  }

  .about-hero-image {
    width: 100%;
  }

  .about-hero-image img {
    width: 100%;
    max-width: 600px;
    height: auto;
  }

}


/* SMALL PHONES */

@media (max-width: 480px) {

  .about-hero {
    padding: 35px 20px;
    gap: 20px;
  }

  .about-hero-text h1 {
    font-size: 29px;
  }

  .about-hero-text p {
    font-size: 14px;
  }

}
</style>